import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { Global } from './global';
import { jsPDF } from "jspdf";
declare let html2canvas: any;
import { Cargo } from '../interfaces/cargo';
import { CatalogItem } from '../interfaces/catalogItem';
import ContentTypes from './content-type-ext.json';
import { SnackBarService } from "src/app/core/services/snackBar.service";
import { Patterns } from './patterns';
import { Fmt } from '../messages/fmt';
import { FormMessages } from '../messages/form-messages.enum';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { Exclusion } from '../interfaces/exclusion';
import { Companies } from './companies';
import { AdditionalCost } from '../interfaces/additionalCost';
import { AdditionalCostCargo } from '../interfaces/additionalCostCargo';
import { Fingerprint } from '../interfaces/fingerprint';
import { User } from '../interfaces/user';
import { ConsignmentCargo } from '../interfaces/consignmentCargo';
import { Vehicle } from '../interfaces/vehicle';
import { SaasConfig, ServiceType as SaasServiceType } from '../interfaces/saas-config';
import { ThirdParty, ThirdPartyAddress } from '../interfaces/thirdParty';
import { Destination } from '../interfaces/destination';
import { AddressCargo } from '../interfaces/addressCargo';
import { Origin } from '../interfaces/origin';
import { DateManager } from '../managers/date.manager';
import { StorageService } from '../services/storage.service';
import { LinkedServiceAddress } from '../interfaces/linkedServiceDto';
import { LocationAddress } from '../interfaces/locationAddress';
import { Company } from '../interfaces/company';
import { ServiceType } from '../interfaces/serviceType';
import { CargoStateEnum } from '../enums/cargoState.enum';

@Injectable()
export class Utils {
  constructor(
    private spinner: NgxSpinnerService,
    private patterns: Patterns,
    private global: Global,
    private snackBarService: SnackBarService,
    private formBuilder: FormBuilder,
  ) {

  }

  getPorcentageAdvance(porcentageTypeCargo: number) {
    let porcentageList: Array<object> = [];
    let max = porcentageTypeCargo

    for (let porcentages = 10; porcentages < (max); porcentages += 10) {
      porcentageList.push({
        title: porcentages + "%",
        value: porcentages
      })
    }
    return porcentageList;
  }
  getListHour(): Array<{ value: number, title: string }> {
    let hourList: Array<{ value: number, title: string }> = [];
    for (let hours = 1; hours < 24; hours++) {
      hourList.push({
        title: hours + " h",
        value: hours
      })
    }
    return hourList;
  }

  getListMinute(): Array<{ value: number, title: string }> {
    let minuteList: Array<{ value: number, title: string }> = [];
    for (let minutes = 0; minutes < 60; minutes += 5) {
      minuteList.push({
        title: minutes + " m",
        value: minutes
      })
    }
    return minuteList;
  }

  getListTime(): Array<{ title: string, value: string }> {
    let timeList: Array<{ title: string, value: string }> = [
      { title: '12:01', value: '00:01' },
      { title: '12:30', value: '00:30' }
    ];
    for (let hours = 1; hours < 12; hours++) {
      for (let mins = 0; mins < 60; mins += 30) {
        timeList.push({
          title: hours + ':' + (mins === 0 ? '00' : mins),
          value: hours + ':' + (mins === 0 ? '00' : mins)
        });
      }
    }
    return timeList;
  }

  onErrorRenderImage($event: Event) {
    ($event.target as HTMLImageElement).src = this.global.pathNoImage;
  }

  isDefined(value, anotherValue?) {
    let status = false;
    if (!_.isUndefined(value) && !_.isNull(value)) {
      status = true;
    }
    if (anotherValue) {
      if (status) {
        return value;
      } else {
        return anotherValue;
      }
    } else {
      return status;
    }
  }

  isEmailValid(email: string) {
    return /^[a-z0-9]([-+\.]?[\w]+)*[-+\.]?[a-z0-9]@([a-z0-9][\w-]*\.)+[a-z0-9][\w-]{1,}$/gim.test(email) && email.length <= 100;
  }

  snapshotToArray(snapshot: any) {
    const returnArr = [];
    if (snapshot) {
      snapshot.forEach((childSnapshot: any) => {
        const item = childSnapshot.val();
        if (item && item.latLng && item.latLng.latitude && item.latLng.longitude) {
          // return item.latLng;
          const newItem = this.clone(item);
          delete newItem.latLng;
          item.latLng.key = childSnapshot.key;
          returnArr.push({
            ...item.latLng,
            ...newItem
          });
        }
      });
    }
    return returnArr;
  };

  snapshotToArrayAnomalies(snapshot: any) {
    const returnArr = [];
    if (snapshot) {
      snapshot.forEach((childSnapshot: any) => {
        const item = childSnapshot.val();
        if (item && item.latLng && item.latLng.lat && item.latLng.lng) {
          const newItem = this.clone(item);
          delete newItem.latLng;
          item.latLng.key = childSnapshot.key;
          returnArr.push({
            ...item.latLng,
            ...newItem
          });
        }
      });
    }
    return returnArr;
  };

  getListLocationsCargo(cargo: Cargo) {
    const locationsList = [];
    if (cargo.cargoFeature.uploadDownload.origin.addresses.length > 0) {
      for (let i = 0; i < cargo.cargoFeature.uploadDownload.origin.addresses.length; i++) {
        locationsList.push({
          lat: cargo.cargoFeature.uploadDownload.origin.addresses[i].location.lat,
          lng: cargo.cargoFeature.uploadDownload.origin.addresses[i].location.lng
        });
      }
    }

    let count = 0;
    if (cargo.cargoFeature.uploadDownload.destination.length) {

      for (let i = 0; i < cargo.cargoFeature.uploadDownload.destination.length; i++) {
        count++;
        if (cargo.cargoFeature.uploadDownload.destination[i].addresses.length) {
          let maxSize = cargo.cargoFeature.uploadDownload.destination[i].addresses.length;
          for (let iD = 0; iD < maxSize; iD++) {
            locationsList.push({
              lat: cargo.cargoFeature.uploadDownload.destination[i].addresses[iD].location.lat,
              lng: cargo.cargoFeature.uploadDownload.destination[i].addresses[iD].location.lng
            });
          }
        }
      }
    }
    _.map(locationsList, (location, i) => {
      const position = i + 1;
      location.position = position;
    });

    return locationsList;
  }
  setStateOnHoldAddressCargo(cargo: Cargo): void {
    if (cargo.cargoFeature.uploadDownload.origin.addresses.length > 0) {
      for (let i = 0; i < cargo.cargoFeature.uploadDownload.origin.addresses.length; i++) {
        if (!cargo.cargoFeature.uploadDownload.origin.addresses[i].state) {
          cargo.cargoFeature.uploadDownload.origin.addresses[i].state = 'On hold';
        }
      }
    }

    if (cargo.cargoFeature.uploadDownload.destination.length) {

      for (let i = 0; i < cargo.cargoFeature.uploadDownload.destination.length; i++) {
        if (cargo.cargoFeature.uploadDownload.destination[i].addresses.length) {
          for (let iD = 0; iD < cargo.cargoFeature.uploadDownload.destination[i].addresses.length; iD++) {
            if (!cargo.cargoFeature.uploadDownload.destination[i].addresses[iD].state) {
              cargo.cargoFeature.uploadDownload.destination[i].addresses[iD].state = 'On hold';
            }
          }
        }
      }
    }
  }

  getListGroupLocationsCargo(cargo) {
    let locationsList = this.getListLocationsCargo(cargo);
    let points = [];
    let parts = []
    let max = 24;
    for (let i = 0; i < locationsList.length; i = i + max) {
      parts.push(locationsList.slice(i, i + max + 1));
    }

    for (let i = 0; i < parts.length; i++) {
      let waypoints = [];
      for (let j = 1; j < parts[i].length - 1; j++)
        waypoints.push({ location: parts[i][j], stopover: false });

      points.push({
        origin: parts[i][0],
        destination: parts[i][parts[i].length - 1],
        waypoints: waypoints
      });
    }

    return points;
  }

  getWaypointsObject(points: Array<any>) {
    const waypoints = [];
    for (let j = 1; j < points.length - 1; j++)
      waypoints.push({
        location: points[j],
        stopover: false
      });

    return {
      origin: points[0],
      destination: points[points.length - 1],
      waypoints
    };
  }

  copyElementJSON(element: any) {
    let elementStringify = JSON.stringify(element);
    let elementJSON = JSON.parse(elementStringify);
    return elementJSON;
  }

  convertArrayToObject(array, key) {
    const initialValue = {};
    return array.reduce((obj, item) => {
      return {
        ...obj,
        [item[key]]: item,
      };
    }, initialValue);
  }

  downloadFromUrl(url) {
    let thisClass = this;
    this.spinner.show();
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    setTimeout(() => {
      link.remove();
      thisClass.spinner.hide();
    }, 100);
  }

  downloadFile(response, fileName, type?: string) {
    let thisClass = this;
    this.spinner.show();
    const typeBlob = type ? type : response.type;
    const newBlob = new Blob([response], { type: typeBlob });

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator['msSaveOrOpenBlob']) {
      window.navigator['msSaveOrOpenBlob'](newBlob);
      return;
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);

    const link = document.createElement('a');
    link.href = data;
    // link.download = fileName + "." + newBlob.type;
    link.download = `${fileName}.${this.getExtension(newBlob.type)}`;
    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
      link.remove();
      thisClass.spinner.hide();
    }, 100);
  }

  getExtension(contentType: string) {
    const normalizedContentType = (contentType || '').toLowerCase();
    if (normalizedContentType.startsWith('text/plain')) return 'txt';

    for (let extension in ContentTypes) {
      if (normalizedContentType === (ContentTypes[extension] || '').toLowerCase()) {
        return extension;
      }
    }
    return 'txt';
  }

  companyEnabledExport(nit, idExport) {
    let valueFind = _.find(this.global.companiesEnabledsToExport, function (key) {
      return key === nit;
    });
    return this.isDefined(valueFind);
  }

  canAssignTrailer(vehicle: Vehicle): boolean {
    if (!vehicle || !vehicle.id) return false;
    return vehicle.vehicleType && vehicle.vehicleType.name === "TRACTOCAMION";
  }

  getRandomColorSize(size, opacity?: boolean) {

    let totalDIVs = size;
    let totalColors = totalDIVs;
    let colors = [];
    let count = 1;

    for (let i = 0; i < totalDIVs; i++) {
      let color = "hsl( " + this.makeColorHSL(i, totalColors) + ", 100%, 50% )";
      if (opacity) {
        color = "hsl( " + this.makeColorHSL(i, totalColors) + ", 100%, 50%, 0.4 )";
      }
      colors.push(color);
      if (count === totalDIVs) {
        return colors;
      }
      count++;
    }
  }

  copyMessage(message: string) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = message;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    if (selBox.value != "") this.snackBarService.openSnackBar("Texto copiado al portapapeles", undefined, "success");
  }

  makeColorHSL(colorNum, colors) {
    if (colors < 1) colors = 1;
    return colorNum * (360 / colors) % 360;
  }

  generateCanvaPDF(element: any, orientation: "p" | "portrait" | "l" | "landscape", name: string) {

    let doc = new jsPDF(orientation, "px", "letter");

    var width = doc.internal.pageSize.getWidth();
    var height = doc.internal.pageSize.getHeight();

    let imgData = element.toDataURL('image/png');

    doc.addImage(imgData, 'PNG', 30, 30, width - 50, height - 200);
    // doc.addImage(imgData, 'PNG', 55, 0, null, null);

    doc.save(name + '.pdf');

  }

  generateHTMLPDF(name: string) {
    this.spinner.show();
    const DATA = document.getElementById('htmlDataReport');
    const doc = new jsPDF('l', 'pt', 'a4');
    const options = {
      background: 'white',
      scale: 3
    };
    html2canvas(DATA, options).then((canvas) => {
      const img = canvas.toDataURL('image/PNG');
      const bufferX = 15;
      const bufferY = 0;
      const imgProps = (doc as any).getImageProperties(img);
      const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(img, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined);
      return doc;
    }).then(
      (docResult) => {
        this.spinner.hide();
        docResult.save(`${name + " " + new Date().toISOString()}.pdf`);
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  bytesToSize(bytes) {
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    let i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
  }

  clearFieldsObject(object: any) {
    try {
      return _.pickBy(object, _.identity);
    } catch (e) {
      return object;
    }
  }

  getObjWithValues(object: any) {
    let newObject = {};
    for (const key in object) {
      if ((typeof object[key] === 'number' && object[key] >= 0) || (typeof object[key] === 'string' && object[key].length)) {
        newObject[key] = object[key];
      }
    }
    return newObject;
  }

  selectAllItems(list: Array<any>, isSelectableFunction: Function) {
    list = list.filter((value) => {
      let exclude = false;
      if (isSelectableFunction) {
        const isSelectable = isSelectableFunction(value);
        exclude = !isSelectable;
      }
      return !exclude;
    });

    const listData = _.map(list, (i: any) => {
      if (i) {
        i.checked = true;
        return i;
      }
    }).filter((item: any) => !!item);

    return listData;
  }

  deselectAllItems(list) {
    const listData = _.map(list, (i) => {
      if (i) {
        i.checked = false;
      }
      return i;
    });

    return listData;
  }

  getItemsCheked(list, propertyReturn?: string) {
    const listData = this.clone(list);
    return _.filter(listData, (i) => {
      return !!i.checked;
    }).map((i) => {
      if (propertyReturn && i[propertyReturn]) {
        return i[propertyReturn];
      } else {
        return i;
      }
    });
  }

  createAdditionalCostCargo(additionalCostSelected: AdditionalCost, canAttachService: boolean, fingerprint: Fingerprint) {
    const additionalCost: AdditionalCostCargo = {
      type: additionalCostSelected,
      id: '',
      financialInformation: {
        cost: 0,
        rate: 0
      },
      observation: '',
      fingerPrint: {
        userId: fingerprint.userId,
        userName: fingerprint.userName,
        date: fingerprint.date
      },
      consignment: '',
    };
    switch (additionalCostSelected.name) {
      case 'Servicios de escolta':
        additionalCost.observation = 'Electrónico';
        break;
      case 'Servicio descargue':
        additionalCost.toPay = {
          code: 'D',
          description: 'DESTINATARIO'
        }
        break;
      case 'Servicio cargue':
        additionalCost.toPay = {
          code: 'R',
          description: 'REMITENTE'
        }
        break;
      case 'Stand by':
        canAttachService ?
          additionalCost.toPay = {
            code: 'C',
            description: 'CONDUCTOR'
          }
          :
          additionalCost.toPay = {
            code: 'R',
            description: 'REMITENTE'
          };
        break;
    }
    return additionalCost;
  }

  clearCargos(cargos: Cargo[]) {
    return cargos.map((i) => {
      delete i.checked;
      return i;
    });
  }

  public enableSelectItemByList(typeList: string): boolean {
    return [
      'advanceState',
      'paymentExtraAdvanceCargo',
      'paymentAdditionalCostsCargo',
      'paymentAdvanceCargo',
      'paymentBalanceCargo',
      'paymentTravelExpenses',
      'charges',
      'approvePayments',
      'rndcFulfillments',
      'withoutPayment'
    ].includes(typeList);
  }

  replaceAmpersand(value: string): string {
    if (!value || typeof value !== 'string') return value;
    return value.replace(/&/g, 'Y');
  }

  isImage(file: File | FileList): boolean {
    try {
      if (file instanceof FileList) {
        if (!file.length) return false;
        return Object.keys(file).every(img => file[img].type.match(/image\/*/));
      }
      return !!file.type.match(/image\/*/)
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  isPDF(file: File): boolean {
    return file && file.type && file.type === 'application/pdf';
  }


  getImageBase64(file: File): Promise<string> {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      try {
        if (!this.isImage(file)) reject();
        if (file) {
          reader.readAsDataURL(file);
          reader.onload = (e) => {
            resolve(reader.result as string);
          };
        }
      } catch (e) {
        console.error(e);
        reject();
      }
    });
  }

  getPdfBase64(file: File): Promise<string> {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      if (!this.isPDF(file)) reject();
      try {
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          resolve(reader.result as string);
        };
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  clone(value: any) {
    if (value) {
      const newValue = JSON.stringify(value);
      return JSON.parse(newValue);
    }
  }

  getDocumentType(documentId: string): CatalogItem {
    const documentType: CatalogItem[] = this.global.documenTypes.filter((obj) => {
      return obj.id === documentId;
    });
    if (documentType.length) {
      return documentType[0];
    }
    return null;
  }

  toCapitalize(value: string): string {
    try {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    } catch (e) {
      return value;
    }
  }

  listToDefault(list: Array<any>, key: string, label?: string) {
    let newList = this.clone(list);
    return newList = newList.map((item) => {
      const keyStr = item[key] ? item[key] : key;
      return {
        key: label ? `${label}${keyStr}` : keyStr,
        value: item
      };
    });
  }

  objIsEmpty(obj: object) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  isEmpty(str): boolean {
    try {
      return str === null || str === undefined || str.length === 0;
    } catch (e) {
      console.error(e);
      return true;
    }
  }
  getNestedValue(obj: any, path: string) {
    try {
      const pathNoSpaces = path.replace(/(\r\n|\n|\r|\t|\ )/gm, "");
      const keys = pathNoSpaces.split('.');
      let currentValue = this.clone(obj);
      for (const key of keys) {
        if (key.includes('[') && key.includes(']')) {
          const arrayKey = key.substring(0, key.indexOf('['));
          const index = parseInt(key.substring(key.indexOf('[') + 1, key.indexOf(']')));

          if (Array.isArray(currentValue[arrayKey]) && currentValue[arrayKey][index] !== undefined) {
            currentValue = currentValue[arrayKey][index];
          } else {
            return undefined;
          }
        } else {
          if (key in currentValue) {
            currentValue = currentValue[key];
          } else {
            return undefined;
          }
        }
      }
      return currentValue;
    } catch (error) {
      return undefined;
    }
  }


  cleanEmptyValues(obj: any) {
    try {
      if (Array.isArray(obj)) {
        return obj
          .map(v => (v && typeof v === 'object') ? this.cleanEmptyValues(v) : v)
          .filter(v => !(v == null));
      } else {
        return Object.entries(obj)
          .map(([k, v]) => [k, v && typeof v === 'object' ? this.cleanEmptyValues(v) : v])
          .reduce((a, [k, v]) => (v == null ? a : (a[k] = v, a)), {});
      }
    } catch (e) {
      return obj;
    }
  }

  daysInDate(days: any) {

    let year = Math.abs(days) / 365;
    let mont = ((year % 1) * 365) / 12;
    let day = ((mont % 1) * 12);

    if (year > 2) {
      return Math.trunc(year) + ' años , ' + Math.trunc(mont) + ' meses y ' + Math.trunc(day) + ' dias';
    }
    if (year >= 1 && year < 2) {
      return Math.trunc(year) + ' año , ' + Math.trunc(mont) + ' meses y ' + Math.trunc(day) + ' dias';
    }
    if (year < 1) {
      return Math.trunc(mont) + ' meses y ' + Math.trunc(day) + ' dias';
    }
    if (year < 1 && mont < 1) {
      return Math.trunc(day) + ' dias';
    }

  }

  arrayGroupBy(list: any[], key: string) {
    try {
      const group = list.reduce((r: any, a) => {
        (r[a[key]] = r[a[key]] || []).push(a);
        return r;
      }, {});
      return group;
    } catch (e) {
      return list;
    }
  }

  getPercentage(value: number, percentage: number): number {
    const valuePercentage: number = (value * percentage) / 100;
    return valuePercentage;
  }

  groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  round(value: number) {
    return Math.round(value);
  }

  errorMessagesCustomized(field: AbstractControl, name: string, minlength?: number, maxlength?: number, min?, max?, customErrors?: { [key: string]: string }): boolean {
    if (!field) return true;
    if (!field.errors) return false;
    const customErrorKeys = Object.keys(customErrors || {});
    let title: string;
    if (!name)
      title = FormMessages.GENERAL_ERROR_DEFAULT;
    else if (field.errors.required)
      title = Fmt.string(FormMessages.MISSING_FIELD, name);
    else if (field.errors.pattern)
      title = Fmt.string(FormMessages.INVALID_FIELD, name);
    else if (field.errors.maxlength)
      title = maxlength ? Fmt.string(FormMessages.MAX_LENGTH_EXCEED, name, maxlength) : Fmt.string(FormMessages.MAX_LENGTH_EXCEED_DEFAULT, name);
    else if (field.errors.minlength)
      title = minlength ? Fmt.string(FormMessages.MIN_LENGTH_NOT_REACHED, name, minlength) : Fmt.string(FormMessages.MIN_LENGTH_NOT_REACHED_DEFAULT, name);
    else if (field.errors.min)
      title = min || min === 0 ? Fmt.string(FormMessages.MIN_VALUE_NOT_REACHED, name, min) : Fmt.string(FormMessages.MIN_VALUE_NOT_REACHED_DEFAULT, name);
    else if (field.errors.max)
      title = max || max === 0 ? Fmt.string(FormMessages.MAX_VALUE_EXCEED, name, max) : Fmt.string(FormMessages.MAX_VALUE_EXCEED_DEFAULT, name);
    else if (field.errors.email)
      title = Fmt.string(FormMessages.INVALID_FIELD, name);
    else if (customErrorKeys.length && customErrorKeys.some(key => field.errors[key]))
      title = customErrors[customErrorKeys.find(key => field.errors[key])];
    else
      title = Fmt.string(FormMessages.GENERAL_ERROR, name);
    title && this.snackBarService.openSnackBar(title, undefined, 'alert');
    return true;
  }

  giveMessageError(formMessagesEnum: string, name?: string, param?): string {
    try {
      if (FormMessages[formMessagesEnum]) return Fmt.string(FormMessages[formMessagesEnum], name, param);
      else if (name) return Fmt.string(FormMessages.GENERAL_ERROR, name);
      else return FormMessages.GENERAL_ERROR_FIELD;
    } catch (error) {
      if (name) return Fmt.string(FormMessages.GENERAL_ERROR, name);
      else return FormMessages.GENERAL_ERROR_FIELD;
    }
  }

  public dataUrlToFile(appType: string, dataType: string, dataurl: string, filename: string): File {
    // 'application/xslx', 'base64'
    const name = `data:${appType};${dataType},${dataurl}`;
    let arr: string[] = name.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  isRequiredField(control: AbstractControl): boolean {
    return !!(control && control.validator && control.validator({} as AbstractControl) && control.validator({} as AbstractControl).required);
  }
  public getDefaultUrlLogo(type: 'mainLogo' | 'white'): string {
    let defaultUrl: string;
    let isTeclogi = location.hostname.search('teclogi') >= 0;

    switch (type) {
      case 'mainLogo':
        defaultUrl = isTeclogi ? '/assets/svg/logotype/color/logotype.svg' : '/assets/svg/logotype/color/logotypeLA.png';
        break;
      case 'white':
        defaultUrl = isTeclogi ? '/assets/svg/logotype/white/logotype-horizontal.png' : '/assets/svg/logotype/white/logotypeWhiteLA.png';
        break;
    }

    return defaultUrl;
  }

  removeEmpty(body) {
    if (typeof body === "object") {
      let newObject = Array.isArray(body) ? [] : {};
      Object.entries(body)
        .filter(
          ([_, value]) => {
            if (typeof value === "string")
              value = value.trim();
            return !(value === null || value === undefined || value === "");
          }
        )
        .map(([key, value]) =>
          (parseInt(key) as any) == (key as any)
            ? (newObject[parseInt(key)] = this.removeEmpty(this.trimIfString(value)))
            : (newObject[key] = this.removeEmpty(this.trimIfString(value)))
        );
      return newObject;
    } else return body;
  }

  trimIfString(value: any) {
    if (typeof value === "string") {
      if (this.patterns.CELLPHONE.test(value) || this.patterns.CELLPHONE_WITH_SPACES.test(value) || this.patterns.ONLY_NUMBERS.test(value) || this.patterns.ONLY_NUMBERS_WITH_SPACES.test(value)) value = value.replace(/\s/g, "").trim();
      else value = value.replace(/\s+/g, ' ').trim();
    }
    return value;
  }

  public numberMaskToNumber(valueString: string): string {
    if (valueString === null) return '';

    // Eliminar cualquier caracter que no sea número o el punto decimal
    let parts = valueString.toString().split('.');

    // Asegurar que solo hay un punto decimal
    let integerPart = parts[0].replace(/\D/g, '');  // Parte entera, eliminando caracteres no numéricos
    let decimalPart = parts[1] || '';  // Parte decimal (si existe)

    // Aplicar el formato de miles solo a la parte entera
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Reconstruir el número, incluyendo la parte decimal si existe
    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
  }

  public parseNumber(value: string): number {
    if (!value) return 0;

    // Eliminar las comas (formato de miles)
    let cleanValue = value.replace(/,/g, '');

    // Convertir a número flotante o entero
    return cleanValue.includes('.') ? parseFloat(cleanValue) : parseInt(cleanValue, 10);
  }

  public formatNumberWithCommas(value: number): string {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getParamsFormatted(paramsFilter: string, pageKey?: number, pageSize?: number): HttpParams {
    let params = new HttpParams();
    if (paramsFilter) {
      paramsFilter.split('&').forEach(param => {
        if (param) {
          const [key, value] = param.split('=');
          if (key && value) {
            params = params.append(key, value);
          }
        }
      });
    }
    if (pageKey && pageSize) {
      params = params.append('pageKey', pageKey.toString());
      params = params.append('pageSize', pageSize.toString());
    }
    return params;
  }

  public get isTeclogiUserOrClient(): boolean {
    return StorageService.checkStorage().getItem('_companyId') === Companies.companiesNIT.TECLOGI
  }

  getTeclogiDefaultTimePact(): { hours: number, minutes: number } {
    return { hours: 1, minutes: 0 };
  }

  isTeclogiTimePactOption(hours: number, minutes: number): boolean {
    const total = (Number(hours) || 0) * 60 + (Number(minutes) || 0);
    return total > 0 && total <= 60;
  }

  /**
   * Determina si el tiempo pactado está vacío (sin valor real) y por tanto debe tomar el
   * default TECLOGI de 1 hora. Trata 0, null, undefined y '' como vacío (total <= 0), pero
   * conserva cualquier valor real, incluidos los legacy > 1 hora (total > 0).
   */
  isEmptyTeclogiTimePact(hours: number, minutes: number): boolean {
    return ((Number(hours) || 0) * 60 + (Number(minutes) || 0)) <= 0;
  }

  getTimePactHourList(isTeclogi: boolean, baseHourList: Array<{ value: number, title: string }>, currentHours?: number): Array<{ value: number, title: string }> {
    if (!isTeclogi) return baseHourList;
    const list = [
      { value: 0, title: '0 h' },
      { value: 1, title: '1 h' }
    ];
    if (this.isDefined(currentHours) && Number(currentHours) !== 0 && Number(currentHours) !== 1) {
      list.push({ value: Number(currentHours), title: `${Number(currentHours)} h` });
    }
    return list;
  }

  getTimePactMinuteList(isTeclogi: boolean, hoursValue: number, baseMinuteList: Array<{ value: number, title: string }>, currentMinutes?: number): Array<{ value: number, title: string }> {
    if (!isTeclogi) return baseMinuteList;
    const list = Number(hoursValue) === 1 ? [{ value: 0, title: '0 m' }] : baseMinuteList.filter(minute => minute.value > 0);
    if (this.isDefined(currentMinutes) && !list.some(minute => minute.value === Number(currentMinutes))) {
      list.push({ value: Number(currentMinutes), title: `${Number(currentMinutes)} m` });
    }
    return list;
  }

  getTeclogiTimePactOptionsWithCurrent(filteredOptions: Array<{ hours: number, minutes: number, description: string }>, currentHours: number, currentMinutes: number): Array<{ hours: number, minutes: number, description: string }> {
    if (!this.isDefined(currentHours) || !this.isDefined(currentMinutes)) return filteredOptions;
    const h = Number(currentHours), m = Number(currentMinutes);
    if (filteredOptions.some(option => option.hours === h && option.minutes === m)) return filteredOptions;
    const description = `${h ? h + ' hr ' : ''}${m ? m + ' min' : ''}`;
    return [...filteredOptions, { hours: h, minutes: m, description }];
  }

  public vehicleIsOwnFleet(vehicle: Vehicle, saasConfig: SaasConfig): boolean {
    if (!vehicle) return false;
    if (!saasConfig || !saasConfig.serviceTypes || !saasConfig.transportCompanyId) return false;
    if (!saasConfig.serviceTypes.includes(SaasServiceType.FREIGHT_TRANSPORT)) return false;
    if (this.isDefined(vehicle.ownFleetHolder))
      return vehicle.ownFleetHolder.slice(0, 9) === saasConfig.companyId.slice(0, 9);
    const adminDocument = this.getNestedValue(vehicle, 'administrator.document');
    const ownerDocument = this.getNestedValue(vehicle, 'owner.document');
    if (adminDocument && adminDocument.slice(0, 9) === saasConfig.transportCompanyId.slice(0, 9)) return true;
    if (ownerDocument && ownerDocument.slice(0, 9) === saasConfig.transportCompanyId.slice(0, 9)) return true;
    return false;
  }

  public canOpenLogisticTimes(cargo: Cargo): { canView: boolean, canOpen?: boolean, reason?: string } {
    if (!cargo || !cargo.ministry || !this.isTransportService(cargo)) return { canView: false };
    if (![CargoStateEnum.START_SERVICE, CargoStateEnum.END_SERVICE].includes(cargo.state)) return { canView: false };
    const originAddresses: AddressCargo[] = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.origin.addresses');
    if (!originAddresses || !originAddresses.length) return { canView: false };
    if (originAddresses.some(address => !address || !address.durationTime || !address.durationTime.endDate))
      return { canView: true, canOpen: false, reason: 'Se requiere completar todas las direcciones de origen' };
    const destinations: Destination[] = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
    if (!destinations || !destinations.length) return { canView: false };
    if (destinations.some(destination => !destination || !destination.addresses || !destination.addresses.length ||
      destination.addresses.some(address => !address || !address.durationTime || !address.durationTime.endDate)))
      return { canView: true, canOpen: false, reason: 'Se requiere completar todas las direcciones de destino' }
    if (!cargo.manifestAuthorization)
      return { canView: true, canOpen: false, reason: 'Se requiere generar el manifiesto' };
    if (!cargo.requiresMinistryLogisticTimes) {
      if (this.isSameCity(cargo))
        return { canView: true, canOpen: false, reason: 'No aplica para servicios urbanos' };
      return { canView: true, canOpen: false, reason: 'Este servicio no requiere configurar tiempos logísticos' };
    }
    return { canView: true, canOpen: true };
  }

  public getDeepDifferencesObjs(obj1: any, obj2: any): any {
    if (obj1 === obj2 || obj2 === null || obj2 === undefined || obj2 === "") {
      return null;
    }

    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return obj2;
    }

    const differences: any = {};
    const keys = Object.keys(obj2);

    for (const key of keys) {
      const diff = this.getDeepDifferencesObjs(obj1[key], obj2[key]);
      if (diff !== null) {
        differences[key] = diff;
      }
    }

    return Object.keys(differences).length > 0 ? differences : null;

  }

  /**
    * @description Creates a FormGroup from an object, handling nested objects and arrays recursively
    * @param obj The object to convert to FormGroup
    * @returns FormGroup
  */
  public createFormGroupFromObject(obj: Object): FormGroup {
    const group: { [key: string]: any } = {};
    Object.keys(obj).forEach(key => {
      const value = obj[key];
      if (Array.isArray(value)) {
        const formArray = this.formBuilder.array([]);
        value.forEach((item, index) => {
          if (typeof item === 'object' && item !== null) formArray.insert(index, this.createFormGroupFromObject(item));
          else formArray.insert(index, this.formBuilder.control(item));
        });
        group[key] = formArray;
      }
      else if (typeof value === 'object' && value !== null)
        group[key] = this.createFormGroupFromObject(value);
      else group[key] = [value];
    });
    return this.formBuilder.group(group);
  }

  /**
    * @description Creates a FormGroup from an object ensuring all required fields exist
    * This guarantees that all specified fields have controls, even if the object has null/undefined values
    * @param obj The object to convert to FormGroup (can be partial)
    * @param fieldsConfig Configuration object with field names as keys and default values or configs as values
    * @returns FormGroup
    * 
    * @example
    * // Simple usage with default values
    * const fieldsConfig = {
    *   name: '',
    *   age: 0,
    *   active: true
    * };
    * const formGroup = utils.createFormGroupWithRequiredFields(user, fieldsConfig);
    * 
    * @example
    * // Usage with optional fields
    * const fieldsConfig = {
    *   category: '',
    *   numberLicense: '',
    *   restrictions: '',
    *   active: true,
    *   preview: false
    * };
    * // Optional fields are only added if they exist in the object
    * if (obj.isLicenseExpirationDate !== undefined) {
    *   fieldsConfig.isLicenseExpirationDate = obj.isLicenseExpirationDate;
    * }
  */
  public createFormGroupWithRequiredFields<T>(
    obj: Partial<T> | null | undefined,
    fieldsConfig: { [key: string]: any }
  ): FormGroup {
    const group: { [key: string]: any } = {};
    Object.keys(fieldsConfig).forEach(key => {
      const defaultValue = fieldsConfig[key];
      const objValue = obj && obj[key] !== undefined && obj[key] !== null
        ? obj[key]
        : undefined;
      const value = objValue !== undefined ? objValue : defaultValue;
      group[key] = this.formBuilder.control(value);
    });

    return this.formBuilder.group(group);
  }

  rebuildFormArray<T>(
    formArray: FormArray,
    values: T[],
    createControl: (value: T) => AbstractControl,
  ): void {
    const controls = values.map(v => createControl(v));
    if (controls.length === 0) {
      formArray.clear();
    } else {
      controls.forEach((control, index) => {
        if (index < formArray.length) formArray.setControl(index, control);
        else formArray.push(control);
      });
      while (formArray.length > controls.length) formArray.removeAt(formArray.length - 1);
    }
  }

  getCargoLastPointLocation(cargo: Cargo): { date: Date, address: string, city: string } {
    const lastPointLocation = this.getNestedValue(cargo, 'lastPointLocation.fingerprint.date');
    const lastPointLocationDate = lastPointLocation ? DateManager.stringToDate(lastPointLocation) : null;

    const lastPointLocationCity = this.getNestedValue(cargo, 'lastPointLocation.city');
    const lastPointLocationAddress = this.getNestedValue(cargo, 'lastPointLocation.address');
    return {
      date: lastPointLocationDate,
      address: lastPointLocationAddress ? lastPointLocationAddress : '-',
      city: lastPointLocationCity ? lastPointLocationCity : '-'
    };
  }

  renameFile(file: File, newName: string, extension?: string): File {
    const currentExtension = extension ? extension : file.name.split('.').pop();
    return new File([file], `${newName}.${currentExtension}`, {
      type: file.type,
      lastModified: file.lastModified
    });
  }

  decodePolyline(encoded: string): { lat: number, lng: number }[] {
    const path = [];
    let index = 0;
    let lat = 0;
    let lng = 0;

    while (index < encoded.length) {
      let shift = 0;
      let result = 0;
      let byte;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lat += ((result & 1) ? ~(result >> 1) : (result >> 1));
      shift = 0;
      result = 0;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lng += ((result & 1) ? ~(result >> 1) : (result >> 1));
      path.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }

    return path;
  }

  formatStorageValues(value: string) {
    let [integerPart, decimalPart] = value.split('.');
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return decimalPart ? `${integerPart},${decimalPart}` : integerPart;
  }

  formatNumber(value: string): string {
    let validValue = value.replace(/[^0-9,]/g, '');
    const commaIndex = validValue.indexOf(',');
    const commaCount = (validValue.match(/,/g) || []).length;
    if (commaCount > 1) validValue = validValue.slice(0, commaIndex + 1) + validValue.slice(commaIndex + 1).replace(/,/g, '');
    let cleanedValue = validValue.replace(/\./g, '');
    const [integerPart] = cleanedValue.split(',');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (commaIndex !== -1 ? validValue.slice(commaIndex) : '');
    return formattedIntegerPart;
  }

  normalizeValueCurrencyMask(value: string | number): number {
    if (typeof value === 'number') return value;
    let cleanedValue = value.replace(/\./g, '');
    cleanedValue = cleanedValue.replace(/,/g, '.');
    const result = parseFloat(cleanedValue);
    return isNaN(result) ? 0 : result;
  }

  decodeFilters(filters: string): Object {
    const filtersFormatted = {};
    const arrayElements = ['nits', 'labels', 'states'];
    filters.split("&").forEach((filter) => {
      if (filter && filter.split("=")[1] && filter.split("=")[1] !== "undefined")
        if (arrayElements.includes(filter.split("=")[0]))
          filtersFormatted[filter.split("=")[0]] = decodeURIComponent(filter.split("=")[1]).split(',');
        else
          filtersFormatted[filter.split("=")[0]] = decodeURIComponent(filter.split("=")[1]);
    })
    return filtersFormatted;
  }

  formatDecimal(value: number): number {
    return Number(value.toFixed(1));
  }

  getNextAddressCargo(cargo: Cargo, addressType: 'origin' | 'destination', indexAddress: number, indexDownload?: number): { type: 'origin' | 'destination', address: AddressCargo, origin?: Origin, destination?: Destination } | null {
    if (addressType === 'origin') {
      const origin = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.origin');
      const nextOriginAddress: AddressCargo = this.getNestedValue(origin, `addresses.${indexAddress + 1}`);
      if (nextOriginAddress) return { type: 'origin', address: nextOriginAddress, origin: origin };
      const firstDestination = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination.0');
      const firstDestinationAddress: AddressCargo = this.getNestedValue(firstDestination, `addresses.0`);
      if (firstDestinationAddress) return { type: 'destination', address: firstDestinationAddress, destination: firstDestination };
    } else {
      const sameDestination = this.getNestedValue(cargo, `cargoFeature.uploadDownload.destination.${indexDownload}`);
      const nextDestinationAddress: AddressCargo = this.getNestedValue(sameDestination, `addresses.${indexAddress + 1}`);
      if (nextDestinationAddress) return { type: 'destination', address: nextDestinationAddress, destination: sameDestination };
      const nextDestination = this.getNestedValue(cargo, `cargoFeature.uploadDownload.destination.${indexDownload + 1}`);
      const firstAddressNextDestination: AddressCargo = this.getNestedValue(nextDestination, `addresses.0`);
      if (firstAddressNextDestination) return { type: 'destination', address: firstAddressNextDestination, destination: nextDestination };
    }
    return null;
  }

  getPreviousAddressCargo(cargo: Cargo, addressType: 'origin' | 'destination', indexAddress: number, indexDownload?: number): { type: 'origin' | 'destination', address: AddressCargo, origin?: Origin, destination?: Destination } | null {
    if (addressType === 'origin') {
      const origin = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.origin');
      const previousOriginAddress: AddressCargo = this.getNestedValue(origin, `addresses.${indexAddress - 1}`);
      if (previousOriginAddress) return { type: 'origin', address: previousOriginAddress, origin: origin };
    } else {
      const sameDestination = this.getNestedValue(cargo, `cargoFeature.uploadDownload.destination.${indexDownload}`);
      const previousDestinationAddress: AddressCargo = this.getNestedValue(sameDestination, `addresses.${indexAddress - 1}`);
      if (previousDestinationAddress) return { type: 'destination', address: previousDestinationAddress, destination: sameDestination };
      const lastDestination: Destination = this.getNestedValue(cargo, `cargoFeature.uploadDownload.destination.${indexDownload - 1}`);
      if (lastDestination && lastDestination.addresses && lastDestination.addresses.length) {
        const lastAddressPreviousDestination: AddressCargo = this.getNestedValue(lastDestination, `addresses.${lastDestination.addresses.length - 1}`);
        if (lastAddressPreviousDestination) return { type: 'destination', address: lastAddressPreviousDestination, destination: lastDestination };
      }
      const origin: Origin = this.getNestedValue(cargo, `cargoFeature.uploadDownload.origin`);
      if (origin && origin.addresses && origin.addresses.length) {
        const lastAddressOrigin: AddressCargo = this.getNestedValue(origin, `addresses.${origin.addresses.length - 1}`);
        if (lastAddressOrigin) return { type: 'origin', address: lastAddressOrigin, origin: origin };
      }
    }
    return null;
  }

  disableThirdPartyAddress(address: ThirdPartyAddress): { disable: boolean, reason?: string } {
    const id = this.getNestedValue(address, 'address.id');
    if (!id || id === "null" || id === "0") return { disable: true, reason: 'Dirección no disponible' };
    if (!this.thirdPartyAddressIsActive(address)) return { disable: true, reason: 'Dirección inactiva' };
    return { disable: false };
  }

  thirdPartyAddressIsActive(address: ThirdPartyAddress): boolean {
    return address && (!address.state || (!!address.state && address.state.active));
  }

  isSameCity(cargo: Cargo): boolean {
    const originCity = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.origin.name');
    const destinations = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
    return destinations.every((city) => city && city.name === originCity);
  }

  requestContainerInspection(cargo: Cargo, vehicleAssigned: Vehicle): boolean {
    const tripType = this.getNestedValue(cargo, 'cargoModel.tripType.name');
    if (tripType === 'Importación') return false;
    const vehicleType: string = this.getNestedValue(vehicleAssigned, 'vehicleType.name');
    const isContainerService = this.getNestedValue(cargo, 'cargoModel.cargoType.name') === 'Contenedor';
    return !!(isContainerService && vehicleType && (vehicleType.toUpperCase() === 'TRACTOCAMION' || !!vehicleAssigned.trailerId));
  }

  /**
   * Compara dos objetos de manera profunda ignorando el orden de las propiedades
   * @param obj1 Primer objeto a comparar
   * @param obj2 Segundo objeto a comparar
   * @returns true si los objetos son iguales, false si son diferentes
   */
  deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true;
    if (obj1 == null || obj2 == null)
      return obj1 === obj2;
    if (typeof obj1 !== typeof obj2) return false;
    if (typeof obj1 !== 'object')
      return obj1 === obj2;
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
      if (obj1.length !== obj2.length) return false;
      for (let i = 0; i < obj1.length; i++) {
        if (!this.deepEqual(obj1[i], obj2[i])) return false;
      }
      return true;
    }
    if (Array.isArray(obj1) || Array.isArray(obj2)) return false;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1) {
      if (!keys2.includes(key)) return false;
      if (!this.deepEqual(obj1[key], obj2[key])) return false;
    }
    return true;
  }

  /**
   * Procesa un arreglo de cargas y retorna las direcciones ordenadas por fecha
   * @param cargos Array de cargas a procesar
   * @returns Array de direcciones ordenadas por fecha
   */
  getOrderedAddressesByDate(cargos: Cargo[]): Array<LinkedServiceAddress> {
    const allAddresses: Array<LinkedServiceAddress> = [];
    cargos.forEach(cargo => {
      if (!cargo || !cargo.id) return;
      const origin: Origin = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.origin');
      if (origin && origin.addresses && origin.addresses.length > 0) {
        origin.addresses.forEach((address, index) => {
          if (address && address.address) {
            const dateLoad = this.getNestedValue(cargo, 'dateLoad');
            const addressDate = this.getRealDateFromAddress(address, dateLoad);

            allAddresses.push({
              cargoId: cargo.id,
              consecutive: cargo.consecutive,
              address: address,
              city: origin.name || '',
              municipalityCode: origin.municipalityCode || '',
              type: 'origin',
              date: addressDate,
              addressIndex: index
            });
          }
        });
      }
      const destinations: Destination[] = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
      if (destinations && destinations.length > 0) {
        destinations.forEach((destination, destIndex) => {
          if (destination && destination.addresses && destination.addresses.length > 0) {
            destination.addresses.forEach((address, index) => {
              if (address && address.address) {
                const downloadDate = destination.downloadDate || this.getNestedValue(cargo, 'dateLoad');
                const addressDate = this.getRealDateFromAddress(address, downloadDate);

                allAddresses.push({
                  cargoId: cargo.id,
                  consecutive: cargo.consecutive,
                  address: address,
                  city: destination.name || '',
                  municipalityCode: destination.municipalityCode || '',
                  type: 'destination',
                  date: addressDate,
                  addressIndex: index,
                  destinationIndex: destIndex
                });
              }
            });
          }
        });
      }
    });

    return allAddresses.sort((a, b) => {
      return DateManager.dateDiff(a.date, null, b.date, null, 'seconds');
    });
  }

  /**
   * Obtiene la fecha real de una dirección basada en su tiempo y fecha base
   * @param address Dirección de la carga
   * @param baseDate Fecha base (dateLoad o downloadDate)
   * @returns Fecha calculada
   */
  public getRealDateFromAddress(address: AddressCargo, baseDate: string): Date {
    if (!address.time || !baseDate)
      return DateManager.stringToDate(baseDate);
    const time24H = this.timeAmPmTo24H(address);
    const dateString = `${DateManager.stringToDate(baseDate).toISOString().split('T')[0]}T${time24H}`;
    return DateManager.stringToDate(dateString, 'YYYY-MM-DDTHH:mm:ssZ');
  }

  /**
   * Convierte tiempo AM/PM a formato 24 horas
   * @param address Dirección con información de tiempo
   * @returns Tiempo en formato 24 horas
   */
  private timeAmPmTo24H(address: AddressCargo): string {
    if (!address.timeType) return address.time;
    if (address.time.startsWith('12') && address.timeType === 'AM') return address.time.replace('12', '00');
    if (address.time.startsWith('12') && address.timeType === 'PM') return address.time;
    if (address.timeType === 'PM') return `${parseInt(address.time.slice(0, 2)) + 12}:${address.time.slice(3, 5)}`;
    return address.time;
  }

  public formatCurrency(amount: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  public addressHasThirdParty(address: AddressCargo): boolean {
    const thirdPartyConsignment: ThirdParty = this.getNestedValue(address, 'thirdPartyConsignment');
    const location: LocationAddress = this.getNestedValue(address, 'location');
    return !!(address && thirdPartyConsignment && thirdPartyConsignment.branchOffice && thirdPartyConsignment.documentNumber
      && thirdPartyConsignment.documentType && thirdPartyConsignment.name && address.address && location && location.lat && location.lng);
  }

  public isVehicleExoneratedByRtm(vehicle: Vehicle): { isExonerated: boolean, exonerationExpirationDate: Date } {
    if (!vehicle || !vehicle.registrationDate || !vehicle.vehicleType || !vehicle.vehicleType.name || !vehicle.serviceType)
      return { isExonerated: false, exonerationExpirationDate: null };
    let yearsExempted = vehicle.serviceType === 'Público' || vehicle.vehicleType.name === 'MOTOCICLETA' ? 2 : 5;
    const exonerationExpirationDate = DateManager.add(vehicle.registrationDate, yearsExempted, 'years');
    return { isExonerated: yearsExempted ? DateManager.dateDiff(exonerationExpirationDate, null, DateManager.setStartOfDay(new Date())) > 0 : false, exonerationExpirationDate: exonerationExpirationDate };
  }

  public companyIsActive(company: Company): boolean {
    return company && (!company.state || (!!company.state && company.state.active));
  }

  public cargoCreatedGuide(cargo: Cargo): string[] {
    const guides: string[] = [];
    const destinations = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
    if (destinations && destinations.length) {
      destinations.forEach(destination => {
        const addresses = this.getNestedValue(destination, 'addresses');
        if (addresses && addresses.length) {
          addresses.forEach(address => {
            const guidesId = this.getNestedValue(address, 'guidesId');
            if (guidesId && guidesId.length) {
              guides.push(...guidesId);
            }
          });
        }
      });
    }
    return guides;
  }

  /**
   * Verifica si el servicio es de escolta
   * @param cargo Carga a verificar
   * @returns true si el servicio es de escolta, false si no
   */
  public isEscortedService(cargo: Cargo): boolean {
    const serviceType: string = this.getNestedValue(cargo, 'cargoModel.serviceType.id');
    return serviceType === 'escortServices';
  }

  /**
   * Verifica si el servicio es de candado satelital
   * @param cargo Carga a verificar
   * @returns true si el servicio es de candado satelital, false si no
   */
  public isSatelliteLockService(cargo: Cargo): boolean {
    const serviceType: string = this.getNestedValue(cargo, 'cargoModel.serviceType.id');
    return serviceType === 'satelliteLockServices';
  }

  /**
   * Verifica si el servicio es de transporte
   * @param cargo Carga a verificar
   * @returns true si el servicio es de transporte, false si no
   */
  public isTransportService(cargo: Cargo): boolean {
    const serviceType: string = this.getNestedValue(cargo, 'cargoModel.serviceType.id');
    return !serviceType || serviceType === 'transportServices';
  }

  /**
   * Elimina propiedades nulas, undefined o strings vacíos de un objeto
   * @param obj Objeto a limpiar
   * @param recursive Si es true, limpia también objetos anidados (default: true)
   * @returns Nuevo objeto sin propiedades nulas, undefined o strings vacíos
   */

  public removeNullUndefinedEmpty(obj: any, recursive: boolean = true): any {
    if (obj === null || obj === undefined) {
      return undefined;
    }

    if (Array.isArray(obj)) {
      return obj
        .map(item => recursive ? this.removeNullUndefinedEmpty(item, recursive) : item)
        .filter(item => item !== null && item !== undefined && item !== '');
    }

    if (typeof obj !== 'object') {
      return obj === '' ? undefined : obj;
    }

    const cleaned: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];

        // Si el valor es null, undefined o string vacío, lo omitimos
        if (value === null || value === undefined || value === '') {
          continue;
        }

        // Si es recursivo y el valor es un objeto, limpiarlo recursivamente
        if (recursive && typeof value === 'object' && !(value instanceof Date)) {
          const cleanedValue = this.removeNullUndefinedEmpty(value, recursive);
          if (cleanedValue !== undefined && cleanedValue !== null && cleanedValue !== '') {
            cleaned[key] = cleanedValue;
          }
        } else {
          cleaned[key] = value;
        }
      }
    }

    return cleaned;
  }

  public getCargoAssociatedConsignments(cargo: Cargo): string[] {
    const cargoAssociatedConsignments: string[] = [];
    const destinations = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
    if (destinations && destinations.length) {
      destinations.forEach(destination => {
        const addresses = this.getNestedValue(destination, 'addresses');
        if (addresses && addresses.length) {
          addresses.forEach((address: AddressCargo) => {
            const consignments = this.getNestedValue(address, 'consignments');
            if (consignments && consignments.length) {
              cargoAssociatedConsignments.push(...consignments);
            }
          });
        }
      });
    }
    return cargoAssociatedConsignments;
  }

  public getCargoOriginAddressFromConsignment(cargo: Cargo, consignment: ConsignmentCargo)
    : { address: AddressCargo, origin: Origin, indexAddress: number } {
    if (!cargo || !consignment) return null;
    const consignmentAddressId = this.getNestedValue(consignment, 'sender.addressId');
    if (this.isDefined(consignmentAddressId)) {
      const origin = this.getNestedValue(cargo, `cargoFeature.uploadDownload.origin`);
      const address = this.getNestedValue(origin, `addresses.${consignmentAddressId}`);
      if (origin && address)
        return { address: address, origin: origin, indexAddress: consignmentAddressId };
    }
    const consignmentAddress = this.getNestedValue(consignment, 'sender.address');
    if (consignmentAddress) {
      const origin = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.origin');
      const addresses = this.getNestedValue(origin, 'addresses');
      if (addresses && addresses.length) {
        for (let addressIndex = 0; addressIndex < addresses.length; addressIndex++) {
          const address = addresses[addressIndex];
          if (address && address.address === consignmentAddress)
            return { address: address, origin: origin, indexAddress: addressIndex };
        }
      }
    }
    return null;
  }

  public getCargoDestinationAddressFromConsignment(cargo: Cargo, consignment: ConsignmentCargo)
    : { address: AddressCargo, destination: Destination, indexDestination: number, indexAddress: number } {
    if (!cargo || !consignment) return null;
    const consignmentCityId = this.getNestedValue(consignment, 'recipient.cityId');
    const consignmentAddressId = this.getNestedValue(consignment, 'recipient.addressId');
    if (this.isDefined(consignmentCityId) && this.isDefined(consignmentAddressId)) {
      const destination = this.getNestedValue(cargo, `cargoFeature.uploadDownload.destination.${consignmentCityId}`);
      const address = this.getNestedValue(destination, `addresses.${consignmentAddressId}`);
      if (destination && address)
        return { address: address, destination: destination, indexDestination: consignmentCityId, indexAddress: consignmentAddressId };
    }
    const consignmentMunicipalityId = this.getNestedValue(consignment, 'recipient.municipalityCode');
    const consignmentAddress = this.getNestedValue(consignment, 'recipient.address');
    if (consignmentMunicipalityId && consignmentAddress) {
      const destinations = this.getNestedValue(cargo, 'cargoFeature.uploadDownload.destination');
      if (destinations && destinations.length) {
        for (let index = 0; index < destinations.length; index++) {
          const destination = destinations[index];
          if (destination && destination.municipalityCode === consignmentMunicipalityId) {
            for (let addressIndex = 0; addressIndex < destination.addresses.length; addressIndex++) {
              const address = destination.addresses[addressIndex];
              if (address && address.address === consignmentAddress)
                return { address: address, destination: destination, indexDestination: index, indexAddress: addressIndex };
            }
          }
        }
      }
    }
    return null;
  }

  static isFirebaseTimestamp(dateValue: any): boolean {
    return typeof dateValue === 'object' &&
      dateValue !== null &&
      'seconds' in dateValue &&
      ('nanoseconds' in dateValue || 'nanos' in dateValue);
  }
  static getNanoseconds(dateValue: any): number {
    return 'nanoseconds' in dateValue ? dateValue.nanoseconds : dateValue.nanos;
  }

  /**
   * Convierte un timestamp de Firebase (con seconds y nanoseconds) o una fecha en cualquier formato a un objeto Date
   * @param dateValue - Puede ser un timestamp de Firebase {seconds: number, nanoseconds: number}, un Date, un string, o null/undefined
   * @returns Date | null - Retorna un objeto Date si se puede convertir, null en caso contrario
   */
  static firebaseTimestampToDate(dateValue: any): Date | null {
    if (!dateValue) {
      return null;
    }

    // Si la fecha viene como timestamp de Firebase
    if (this.isFirebaseTimestamp(dateValue)) {
      const timestamp = dateValue as { seconds: number, nanoseconds: number };
      return new Date(timestamp.seconds * 1000 + this.getNanoseconds(dateValue) / 1000000);
    }

    // Si ya es una fecha válida
    if (dateValue instanceof Date) {
      return dateValue;
    }

    // Si es un string, intentar convertirlo
    if (typeof dateValue === 'string') {
      const parsedDate = new Date(dateValue);
      // Verificar que la fecha sea válida
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
    }

    return null;
  }

  public openLinkNewTab(url: string): void {
    const forcedUrl = `${window.location.origin}${window.location.pathname}#${url.startsWith('/') ? url : `/${url}`}`;
    const newWindow = window.open(forcedUrl, '_blank');
    if (!newWindow) window.location.href = forcedUrl;
  }

  public openCargoNewTab(cargo: Cargo) {
    const path = this.getCargoPathByState(cargo);
    this.openLinkNewTab(path.shortPath);
  }

  public getCargoPathByState(cargo: Cargo): { shortPath: string, fullPath: string } {
    if (!cargo || !cargo.consecutive || !cargo.state) return { shortPath: '', fullPath: '' };
    let path = '';
    if (cargo.state === CargoStateEnum.REQUEST)
      path = `/service-request-form/menu-service/${cargo.consecutive}`;
    else if (cargo.state === CargoStateEnum.START_SERVICE)
      path = `/cargo/tracking/${cargo.consecutive}`;
    else
      path = `/cargo/detail/${cargo.consecutive}`;
    return { shortPath: path, fullPath: `${window.location.origin}${window.location.pathname}#${path}` };
  }
}
